var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReservationTakeUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.833008C11.0832 0.833008 11.9995 1.53347 12.3496 2.5H15.833C16.7497 2.5 17.5 3.25033 17.5 4.16699V15.834C17.4997 16.7504 16.7495 17.5 15.833 17.5H4.16699C3.25049 17.5 2.50027 16.7504 2.5 15.834V4.16699C2.5 3.25033 3.25033 2.5 4.16699 2.5H7.65039C8.00046 1.53347 8.91677 0.833008 10 0.833008ZM6 11H8V14H12V11H14L10 7L6 11ZM10 2.5C9.54167 2.5 9.16699 2.87565 9.16699 3.33398C9.16726 3.7921 9.54183 4.16699 10 4.16699C10.4582 4.16699 10.8327 3.7921 10.833 3.33398C10.833 2.87565 10.4583 2.5 10 2.5Z",
    fill: "#14AC63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservationTakeUp);
export default __webpack_public_path__ + "static/media/ReservationTakeUp.9aabff456102425183f6491d518158d3.svg";
export { ForwardRef as ReactComponent };